"use strict"

export default class AdminController {
  /*@ngInject*/
  constructor(User, $http, Auth, $window) {
    // Use the User $resource to fetch all users
    // checking user seems to be important for authentication
    this.users = User.query()
    this.$http = $http

    this.addCampsiteData()
    this.setDefaultValues()
    this.Auth = Auth
    this.window = $window
    this.includeMarkersInDuplicate = false
    this.resetDuplicateMarkersPosition = false

    this.Auth.getCurrentUser().then((response) => {
      this.userRole = response.role
      if (response.role !== "admin") {
        this.window.location = "/login"
      } else {
        this.pageReady = true
      }
    })
  }

  getCampsiteDataByCampsiteId(id) {
    return this.campsites.find((campsite) => campsite._id === id)
  }

  setDefaultValues() {
    this.newCampsiteName = ""
    this.newCampsiteCenterLat = 0
    this.newCampsiteCenterLng = 0
    this.newCampsiteDefaultZoom = 17
    this.newCampsiteNorthEastLat = 0
    this.newCampsiteNorthEastLng = 0
    this.newCampsiteSouthWestLat = 0
    this.newCampsiteSouthWestLng = 0
  }

  deleteAllCampsiteMarkers(campsiteName, campsiteVersion) {
    const campsiteVersionStr = campsiteVersion ? campsiteVersion : ""
    this.$http.get(`/api/markers/${campsiteName}${campsiteVersionStr}`).then((markersArray) => {
      // eslint-disable-next-line array-callback-return
      markersArray.data.map((marker) => {
        this.$http.delete("/api/markers/" + marker._id, {}).then(() => {
          console.log("marker successfully deleted")
        })
      })
    })
  }

  addCampsiteData() {
    this.$http.get("/api/campsites").then((res) => {
      this.campsites = res.data
    })
  }

  setCampsiteActive(campsiteId) {
    this.campsites.map((campsite) => {
      if (campsite.active) {
        return this.$http.put(`/api/campsites/${this.campsiteinfo._id}`, { active: false }).then(
          (response) => {
            console.log(response, "deactiveated a campsite")
          },
          (failureCallback) => {
            console.error(failureCallback)
          }
        )
      }
    })

    return this.$http.put(`/api/campsites/${campsiteId}`, { active: true }).then(
      (response) => {
        console.log(response)
      },
      (failureCallback) => {
        console.error(failureCallback)
      }
    )
  }

  setVersionAsNull(campsite) {
    const campsiteCopy = Object.assign({}, campsite)
    campsiteCopy.version = null
    return this.$http.put(`/api/campsites/${campsite._id}`, campsiteCopy).then(
      (response) => {
        console.log(response, "updated the parent campstie with this version")
      },
      (failureCallback) => {
        console.error(failureCallback)
      }
    )
  }

  applyVersionChangesToBaseCampsite(campsite) {
    const campsiteCopy = Object.assign({}, campsite)
    Reflect.deleteProperty(campsiteCopy, "__v")
    Reflect.deleteProperty(campsiteCopy, "_id")
    campsiteCopy.parentCampsiteId = null
    return this.$http.put(`/api/campsites/${campsite.parentCampsiteId}`, campsiteCopy).then(
      (response) => {
        console.log(response, "updated the parent campstie with this version")
      },
      (failureCallback) => {
        console.error(failureCallback)
      }
    )
  }

  addMarkersData(oldCampsiteName, newCampsiteName, version) {
    this.$http.get(`/api/markers/${oldCampsiteName}`).then((markersArray) => {
      console.log(markersArray)
      // eslint-disable-next-line array-callback-return
      markersArray.data.map((marker) => {
        const markerCopy = Object.assign({}, marker)
        Reflect.deleteProperty(markerCopy, "_id")
        Reflect.deleteProperty(markerCopy, "__v")
        markerCopy.campsite = `${newCampsiteName}${version}`
        if (this.resetDuplicateMarkersPosition) {
          markerCopy.lat = 100
          markerCopy.lng = 100
        }
        this.$http.post("/api/markers", markerCopy).then(() => {
          console.log("Marker Added!!")
        })
      })
    })
  }

  duplicateCampsite(campsiteId) {
    console.log("creating duplicate campsite")
    const campsiteData = this.getCampsiteDataByCampsiteId(campsiteId)
    const campsiteDataCopy = Object.assign({}, campsiteData)
    Reflect.deleteProperty(campsiteDataCopy, "_id")
    Reflect.deleteProperty(campsiteDataCopy, "__v")
    let versionForDuplicate = campsiteData.version ? campsiteData.version + 1 : 2
    campsiteDataCopy.name = `${campsiteData.name}`
    campsiteDataCopy.version = versionForDuplicate
    campsiteDataCopy.parentCampsiteId = campsiteData._id
    this.createCampsite(campsiteDataCopy)

    if (this.includeMarkersInDuplicate) {
      this.addMarkersData(campsiteData.name, campsiteDataCopy.name, versionForDuplicate)
    }
  }

  createCampsite(campsiteData) {
    console.log("creating campsite")
    if (!campsiteData) {
      campsiteData = {
        name: this.newCampsiteName,
        centerlat: this.newCampsiteCenterLat,
        centerlng: this.newCampsiteCenterLng,
        defaultzoom: this.newCampsiteDefaultZoom,
        mbnorthEast: {
          lat: this.newCampsiteNorthEastLat,
          lng: this.newCampsiteNorthEastLng,
        },
        mbsouthWest: {
          lat: this.newCampsiteSouthWestLat,
          lng: this.newCampsiteSouthWestLng,
        },
        version: 1,
      }
    }
    this.$http.post("/api/campsites", campsiteData).then(() => {
      console.log("Campsite Added!!")
    })
  }

  deleteCampsite(campsiteId) {
    this.$http.delete("/api/campsites/" + campsiteId, {}).then(() => {
      console.log("campsite successfully deleted")
    })
  }

  delete(user) {
    user.$remove()
    this.users.splice(this.users.indexOf(user), 1)
  }
}
